<template>
  <div class="col-md-12 user-edit-profile">
    <div class="title">ХЭРЭГЛЭГЧИЙН МЭДЭЭЛЭЛ ЗАСАХ</div>
    <form action="" class="user-edit-panel-profile" @submit.prevent="sendData">
      <div class="form-group" v-if="bonus">
        <label for="">ОВОГ / Last Name : </label>
        <div
          class="user-input"
          v-if="
            user.lastName != 'null' &&
            user.lastName != null &&
            user.lastName != ''
          "
        >
          <p class="form-control">{{ user.lastName }}</p>
        </div>
        <div class="user-input" v-else>
          <input type="text" class="form-control" v-model="lastname" />
        </div>
      </div>

      <div class="form-group">
        <label for="">НЭР / First Name : </label>
        <div
          class="user-input"
          v-if="
            user.firstName != 'null' &&
            user.firstName != null &&
            user.firstName != ''
          "
        >
          <p class="form-control">{{ user.firstName }}</p>
        </div>
        <div class="user-input" v-else>
          <input type="text" class="form-control" v-model="firstname" />
        </div>
      </div>
      <div class="form-group">
        <label for="">Утасны дугаар / Phone Number : </label>
        <div class="user-id">
          <div class="">{{ phone }}</div>
          <img src="@/assets/icon/edit-b.png" alt="" @click="idNumber()" /><span
            @click="idNumber()"
          >
            өөрчлөх</span
          >
        </div>
      </div>
      <div class="form-group">
        <label for="">РЕГИСТЕР / ID number : </label>
        <div
          class="user-input"
          v-if="
            user.customerRegNo != 'null' &&
            user.customerRegNo != null &&
            user.customerRegNo != ''
          "
        >
          <p class="form-control">{{ user.customerRegNo }}</p>
        </div>

        <div class="user-input" v-else>
          <select
            class="form-control"
            style="width: 10%; margin-right: 1%; padding: 0 !important"
            name="regFirst"
            v-model="regFirst"
            disabled="true"
          >
            <option
              v-for="data in letters"
              :value="data.value"
              :key="data.value"
            >
              {{ data.name }}
            </option>
          </select>
          <select
            class="form-control"
            style="width: 10%; margin-right: 1%; padding: 0 !important"
            name="regSecond"
            v-model="regSecond"
            disabled="true"
          >
            <option
              v-for="data in letters"
              :value="data.value"
              :key="data.value"
            >
              {{ data.name }}
            </option>
          </select>
          <input
            type="number"
            class="form-control col-md-6"
            v-model="regThird"
            disabled="true"
          />
        </div>
      </div>
      <!-- <div class="form-group">
                    <label for="">ХҮЙС : </label>
                     <div class="user-input">
                        <p  class="form-control">{{gender}}</p>
                    </div>
            </div>               -->
      <div class="form-group">
        <label for=""
          >Бусад утасны дугаар / Other Phone Number:<span>*</span>
        </label>
        <div class="user-input">
          <input type="text" class="form-control" v-model="phone2" />
        </div>
      </div>
      <div class="form-group">
        <label for=""
          >Е-Баримт бүртгэлийн Дугаар / E-barimt:<span></span>
        </label>
        <div class="user-input column" v-if="bonus">
          <input
            type="number"
            class="form-control"
            v-model="ebarimt"
            @keyup="checkLength"
          />
          <p v-if="ebarimtError" class="ebarimt-error">
            10 оронтой тоогоо оруулна уу !
          </p>
        </div>
        <div class="user-input column" v-else>
          <input
            type="number"
            class="form-control"
            v-model="ebarimt"
            @keyup="checkLength"
            disabled
          />
          <p v-if="ebarimtError" class="ebarimt-error">
            10 оронтой тоогоо оруулна уу !
          </p>
        </div>
      </div>
      <div class="form-group">
        <label for="">имэйл хаяг / Email :<span>*</span> </label>
        <div class="user-input">
          <input type="text" class="form-control" v-model="email" />
        </div>
      </div>
      <div class="form-group">
        <label for="">ХОТ,АЙМАГ / City,Province:<span>*</span> </label>
        <div class="user-input">
          <select
            name=""
            class="form-control user-select"
            @change="change"
            v-model="city"
          >
            <option v-for="data in allCity" :value="data.id" :key="data.id">
              {{ data.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label for="">Сум,дүүрэг / Sum,District:<span>*</span> </label>
        <div class="user-input">
          <select
            name=""
            class="form-control user-select"
            @change="change"
            v-model="dis"
          >
            <option
              v-for="data in allDisctrict"
              :value="data.id"
              :key="data.id"
            >
              {{ data.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label for="">БАГ,ХОРОО / Bag,Khoroo :<span>*</span> </label>
        <div class="user-input" style="flex-direction: column">
          <select name="" class="form-control user-select" v-model="bag">
            <option v-for="data in allKhoroo" :value="data.id" :key="data.id">
              {{ data.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label for="">БАЙР,ГУДАМЖ / Apartment,Street:<span>*</span> </label>
        <div class="user-input">
          <input type="text" class="form-control" v-model="home" />
        </div>
      </div>
      <div class="form-group" style="justify-content: center">
        <input
          type="submit"
          class="btn user-btn"
          value="Хадгалах"
          :disabled="isDisabled"
        />
      </div>
    </form>
    <transition name="fade">
      <Number
        @closeNumber="closeNumber"
        @setNumber="setNumber"
        v-if="checkNumber"
        :phone="user.idPhone"
      ></Number>
    </transition>
    <transition name="fade">
      <Success
        :successMessage="successMessage"
        v-if="successModal"
        @hideSuccessMessage="hideSuccessMessage"
      ></Success>
    </transition>
    <transition name="fade">
      <Error
        :errorMessage="errorMessage"
        v-if="errorModal"
        @hideErrorMessage="hideErrorMessage"
      ></Error>
    </transition>
  </div>
</template>

<script>
import Number from "./number/main";
import Success from "@/views/plugin/success";
import Error from "@/views/plugin/error";
import { User } from "@/mixins/User";
import EventBus from "@/EventBus.js";
import letterJSON from "@/json/data.vue";
export default {
  props: ["user"],
  mixins: [User],
  data() {
    return {
      firstname: "",
      lastname: "",
      register: "",
      regFirst: null,
      regSecond: null,
      regThird: null,
      phone: "",
      phone2: "",
      email: "",
      city: "",
      dis: "",
      bag: "",
      home: "",
      ebarimt: "",
      successMessage: "",
      bagError: "",
      bagErrorMessage: "",
      allCity: [],
      allDisctrict: [],
      allKhoroo: [],
      checkNumber: false,
      successModal: false,
      errorMessage: "",
      errorModal: false,
      isDisabled: false,
      ebarimtError: false,
      letters: letterJSON.myJson,
      bonus: false,
    };
  },
  computed: {
    gender() {
      if (this.user.customerGender === "M") {
        return "Эрэгтэй";
      } else if (this.user.customerGender === "F") {
        return "Эмэгтэй";
      } else {
        return "";
      }
    },
  },
  methods: {
    checkLength() {
      console.log("-------------->" + this.ebarimt);
      let a = this.ebarimt;
      if (a.toString().length >= 11) {
        if (a == 0) {
          this.ebarimtError = false;
        } else {
          this.ebarimtError = true;
        }
      } else {
        this.ebarimtError = false;
      }
    },
    setNumber(phoneNumber) {
      this.phone = phoneNumber;
    },
    checkusername() {
      var userbag = this.bag;
      var isnum = /^\d+$/.test(userbag);
      if (!isnum) {
        this.bagError = true;
        this.bagErrorMessage = "Та зөвхөн тоо оруулна уу ?";
        this.isDisabled = true;
      } else {
        this.bagError = false;
        this.bagErrorMessage = "";
        this.isDisabled = false;
      }
    },
    getCity() {
      let tokenId = localStorage.getItem("authToken");
      let userData = this.$auth.getMe();
      if (tokenId == null || userData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      let cardHolderInfId = userData.cardHolderInfId;
      let type = "City";
      let typeValue = 0;
      this.$axiosApi
        .post(`card/constant/data`, {
          tokenId,
          cardHolderInfId,
          type,
          typeValue,
        })
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.allCity = result.data;
            this.getDistrict();
          }
        })
        .catch(function () {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    getDistrict(value) {
      let tokenId = localStorage.getItem("authToken");
      let userData = this.$auth.getMe();
      if (tokenId == null || userData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      let cardHolderInfId = userData.cardHolderInfId;
      let type = "District";
      let typeValue = value || this.city;
      this.$axiosApi
        .post(`card/constant/data`, {
          tokenId,
          cardHolderInfId,
          type,
          typeValue,
        })
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.allDisctrict = result.data;
            this.getKhoroo();
          }
        })
        .catch(function () {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    getKhoroo(value) {
      let tokenId = localStorage.getItem("authToken");
      let userData = this.$auth.getMe();
      if (tokenId == null || userData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      let cardHolderInfId = userData.cardHolderInfId;
      let type = "Khoroo";
      let typeValue = value || this.dis;
      this.$axiosApi
        .post(`card/constant/data`, {
          tokenId,
          cardHolderInfId,
          type,
          typeValue,
        })
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.allKhoroo = result.data;
          }
        })
        .catch(function () {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    sendData() {
      var ebarimt = this.ebarimt;
      var isnumebarimt = /^\d+$/.test(ebarimt);
      if (ebarimt == 0) {
        this.ebarimtError = false;
        this.send();
      } else {
        if (ebarimt.toString().length <= 10 && isnumebarimt) {
          this.send();
        } else {
          this.ebarimtError = true;
        }
      }
    },
    send() {
      console.log("----" + localStorage.getItem("authToken"));
      var userbag = this.bag;
      var isnum = /^\d+$/.test(userbag);
      if (isnum) {
        this.bagError = false;
        this.isDisabled = true;
        var firstName =
          this.user.firstName != "null" &&
          this.user.firstName != null &&
          this.user.firstName != ""
            ? this.user.firstName
            : this.firstname;
        var lastName =
          this.user.lastName != "null" &&
          this.user.lastName != null &&
          this.user.lastName != ""
            ? this.user.lastName
            : this.lastname;
        if (
          this.regFirst != null &&
          this.regSecond != null &&
          this.regThird != null
        ) {
          if (this.regThird.length > 8 && this.regThird.length < 8) {
            this.bagError = true;
            this.bagErrorMessage =
              "Та регистрийн дугаар 8 оронтой тоо оруулна уу ?";
            return;
          }
          this.register = this.regFirst + this.regSecond + this.regThird;
        }
        var registerNo =
          this.user.customerRegNo != null && this.user.customerRegNo != ""
            ? this.user.customerRegNo
            : this.register;
        var phone = this.phone2;
        var email = this.email;
        var districtId = this.dis;
        var khorooNumber = this.bag;
        var homeAddress = this.home;
        let tokenId = localStorage.getItem("authToken");
        let userData = this.$auth.getMe();
        let vatCustomerNo = this.ebarimt;
        if (tokenId == null || userData == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }

        let cardHolderInfId = userData.cardHolderInfId;

        this.$bonusApi
          .post(
            `bonus-card/update/holderMyInfo`,
            {
              tokenId,
              cardHolderInfId,
              phone,
              email,
              districtId,
              khorooNumber,
              homeAddress,
              vatCustomerNo,
              firstName,
              lastName,
              registerNo,
            },
            {
              headers: {
                "Content-Type": "application/json",
                "Accept-Language": "mn",
              },
            }
          )
          .then((response) => {
            if (response.data.status === 1) {
              this.successEdit();
            } else {
              this.errorMessage = response.data.message;
              this.errorModal = true;
            }
            this.isDisabled = false;
          })
          .catch((error) => {
            this.isDisabled = false;
            this.errorMessage =
              (error.response && error.response.data && error.response.data.message) ||
              "Мэдээлэл хадгалахад алдаа гарлаа.";
            this.errorModal = true;
          });
      } else {
        this.bagError = true;
        this.bagErrorMessage = "Та зөвхөн тоо оруулна уу ?";
      }
    },
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    isDesktop() {
      if (device.mobile()) {
        return true;
      } else {
        return false;
      }
    },
    cardInfoList() {
      var cardHolderInfo = this.$auth.getCardInfo();
      if (cardHolderInfo.CartType === "Bonus") {
        this.bonus = true;
      }
    },
  },
  created() {
    var return_value = this.isDesktop();
    console.log(return_value, "USER DATA");
    if (return_value) {
      this.$router.push("/info");
    }
    this.getCity();
    this.phone = this.user.idPhone;
    this.email = this.user.customerEMail;
    this.phone2 = this.user.customerPhone;
    this.home = this.user.customerAddressHome;
    this.ebarimt = this.user.vatCustomerNo;
    this.city = this.user.customerAddressCity;
    this.dis = this.user.customerAddressDistrict;
    this.bag = this.user.customerAddressKhoroo;
    this.cardInfoList();
  },
  components: {
    Success,
    Number,
    Error,
  },
};
</script>

<style scoped>
.user-select {
  width: 70%;
  font-size: 13px;
  height: 30px;
}
.user-edit-panel-profile .user-input p {
  margin: 0;
  width: 70%;
  height: 30px;
  font-size: 13px;
  border: none;
}
.user-id {
  height: 30px;
  flex: 2;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.user-id div {
  padding: 0.375rem 0.75rem;
  width: 149px;
  height: 30px;
  mix-blend-mode: multiply;
  border-radius: 3px;
  background-color: #ebebeb;
  font-size: 12px;
}
.user-id img {
  margin-left: 13px;
  width: 17px;
  height: 16px;
  display: flex;
  align-self: center;
  cursor: pointer;
}
.user-id span {
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.6;
  letter-spacing: normal;
  color: #1660ab;
  margin-left: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.error,
.ebarimt-error {
  color: red;
  margin-bottom: 0;
}
.user-edit-panel-profile .form-group {
  margin-bottom: 5px;
}
.user-edit-panel-profile {
  margin: 5px;
}
</style>
